import { Component, OnInit, Input } from '@angular/core';
import { UserService } from '../../services/user.service';
import { DialogService } from '../../services/dialog.service';
import { ApiService } from '../../services/api.service';
import { HttpErrorResponse } from '@angular/common/http';
import { GlobalService } from '../../services/global.service';

import { json } from 'express';

@Component({
    selector: 'sd-follow',
    templateUrl: './follow.component.html',
    styleUrls: ['./follow.component.scss']
})

export class FollowComponent implements OnInit {

    @Input() data: any;
    from = '';
    slug = '';
    isFollowing: Boolean = false;
    isSameArtist: Boolean = false;
    followLoading: Boolean = false;
    multifollow: Boolean = false;
    typeMultifollow: Boolean = false;
    constructor(
        private api: ApiService,
        public user: UserService,
        public global: GlobalService,
        public dialog: DialogService
    ) {

    }

    ngOnInit() {
        this.from = this.data.from;
        this.multifollow = this.data.multifollow;
        this.typeMultifollow = this.data.mtype;
        this.global.isMultipleFollow = this.data.isFollowing;
        this.slug = this.data.slug;
        this.isFollowing = this.data.isFollowing;

        // console.log(this.data)


        if (this.user.slug == this.slug) {
            this.isSameArtist = true;
        }
    }

    followArtist(task = 'follow', type='single') {
        this.followLoading = true;
        


        this.api.followArtist(this.slug, task).subscribe(res => {
            this.followLoading = false;
            if (task == 'follow') {
                this.isFollowing = true;
                this.typeMultifollow =  false;
                if(type == 'multiple'){
                    this.typeMultifollow =  true;
                    this.global.isMultipleFollow =  true;

                }
            } else {
                this.isFollowing = false;
                this.typeMultifollow =  false;
                if(type == 'multiple'){
                    this.typeMultifollow =  true;
                    this.global.isMultipleFollow =  false;
                }
            }
            // console.log(res);
        },
            (err: HttpErrorResponse) => {
                if (err.error instanceof Error) {
                    // console.log('Client-side error occured!');
                } else {
                    // console.log('Server-side error occured!', err);
                }

                if (task == 'follow') {
                    this.isFollowing = false;
                    // this.artist.followers_count--;
                } else {
                    this.isFollowing = true;
                    // this.artist.followers_count++;
                }
                this.followLoading = false;
            });
    }


    followArtistV2(task = 'follow', type='single') {
        this.followLoading = true;
        


        this.api.followArtist(this.slug, task).subscribe(res => {
            this.followLoading = false;
            if (task == 'follow') {
                this.isFollowing = true;
                this.typeMultifollow =  false;
                if(type == 'multiple'){
                    this.typeMultifollow =  true;
                    this.global.isMultipleFollow =  true;

                }
            } else {
                this.isFollowing = false;
                this.typeMultifollow =  false;
                if(type == 'multiple'){
                    this.typeMultifollow =  true;
                    this.global.isMultipleFollow =  false;
                }
            }
            // console.log(res);
        },
            (err: HttpErrorResponse) => {
                if (err.error instanceof Error) {
                    // console.log('Client-side error occured!');
                } else {
                    // console.log('Server-side error occured!', err);
                }

                if (task == 'follow') {
                    this.isFollowing = false;
                    // this.artist.followers_count--;
                } else {
                    this.isFollowing = true;
                    // this.artist.followers_count++;
                }
                this.followLoading = false;
            });
    }
}
